import { jsx as _jsx } from "react/jsx-runtime";
import { PropertyAvailabilityCard } from './PropertyAvailabilityCard';
// The calendar view over a search: a lazily-loaded card per property. The
// visible window (from the header toolbar) is the only thing that changes which
// dates are requested; each card fetches its own property's availability for
// that window when it scrolls in.
export const AvailabilityView = ({ contexts, range, dateWindow, adults, hideUnavailable, expansion }) => {
    if (!range || contexts.length === 0) {
        return (_jsx("p", { className: "px-1 py-8 text-sm text-light-midnight", children: "Search a property, city, or region to see the availability calendar." }));
    }
    return (_jsx("div", { className: "flex flex-col gap-6", children: contexts.map(context => (_jsx(PropertyAvailabilityCard, { context: context, dateWindow: dateWindow, adults: adults, hideUnavailable: hideUnavailable, expansion: expansion }, context.property.id))) }));
};
